import { render, staticRenderFns } from "./ListStockTransfer.vue?vue&type=template&id=62162770&"
import script from "./ListStockTransfer.vue?vue&type=script&lang=js&"
export * from "./ListStockTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62162770')) {
      api.createRecord('62162770', component.options)
    } else {
      api.reload('62162770', component.options)
    }
    module.hot.accept("./ListStockTransfer.vue?vue&type=template&id=62162770&", function () {
      api.rerender('62162770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ListStockTransfer.vue"
export default component.exports